import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {

    balance(obj) {
        // console.log('Proses Inventory Report BALANCE : ', obj);
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2','kodeacc', 'namaacc',  'headcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/inventory/balance${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    expired(obj) {
        // console.log('Proses Inventory Report BALANCE : ', obj);
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['withindays', 'kodeacc', 'nmcategory', 'headcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/inventory/expired${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    expiredexport(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['withindays', 'kodeacc','nmcategory', 'headcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/inventory/expiredexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'expired-inventory.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    reorder(obj) {
        // console.log('Proses Inventory Report BALANCE : ', obj);
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['withindays', 'kodeacc', 'headcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/inventory/reorder${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    reorderexport(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['kodeacc', 'headcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/inventory/reorderexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'reorder-inventory.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    balanceexport(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2', 'kodeacc', 'namaacc', 'headcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/inventory/balanceexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'stockbalance.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    balancestore(obj) {
        console.log('Proses Inventory Report BALANCE  per Store/Gudang: ', obj);
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2', 'idStore'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/inventory/balancestore${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    group() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/item/itemcategory`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    headgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/item/headcategory`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    inventorygroup(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/inventorycategory/combo`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    rekondb(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2', 'headcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/inventory/rekondb${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    rekondbexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2', 'headcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/inventory/rekondbexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `inventory_rekon_DB_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    rekonkr(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2', 'headcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/inventory/rekonkr${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    rekonkrexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2', 'headcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/inventory/rekonkrexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `inventory_rekon_CR_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    store() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventory/store`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    stockcard(obj) {
        console.log('Proses Inventory Stock Card : ', obj);
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['itemno', 'asofdate','alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/inventory/stockcard${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    stockcardexport(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['itemno', 'iteminfo','asofdate','alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/inventory/stockcardexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'stockcard.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
};